const apiServerOrigin = process.env.VUE_APP_API_SERVER_ORIGIN;
const adminHKOrigin = process.env.VUE_APP_ADMIN_HK_ORIGIN;
const blockDocViewer = process.env.VUE_APP_BLOCK_DOC_VIEWER === 'TRUE';

const createPersonLink = `${adminHKOrigin}/person/add/`;
const createCompanyLink = `${adminHKOrigin}/company/add/`;

export {
    apiServerOrigin,
    createCompanyLink,
    createPersonLink,
    adminHKOrigin,
    blockDocViewer
}
